/**
 * 防抖
 * @param fn 执行函数
 * @param delay 时间间隔
 * @returns {Function}
 */
export function debounce(fn, delay = 200) {
  var timer = null
  return function() {
    var args = arguments
    var that = this
    clearTimeout(timer)
    timer = setTimeout(function() {
      fn.apply(that, args)
    }, delay)
  }
}
